import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { NavLink, useNavigate} from "react-router-dom";
import Logo from "../assets/webLogo.png";
import { ToastContainer, toast } from "react-toastify";
import axios from "axios";
import "react-toastify/dist/ReactToastify.css";
import { registerRoute } from "../utils/APIroutes";

const Register = () => {
  const navigate = useNavigate();
  const [values, setValues] = useState({
    username: "",
    email: "",
    password: "",
    confirmPassword: "",
  });

  const toastOptions = {
    position: "bottom-right",
    autoClose: 8000,
    draggable: true,
    theme: "dark",
  };

  useEffect(()=>{
    if(localStorage.getItem("chat-app-user")){
      navigate('/')
    }
  },[navigate])
  
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (handleValidation()) {
      const { password, username, email } = values;
      const { data } = await axios.post(registerRoute, {
        username,
        email,
        password,
      });
      if (data.status === false) {
        toast.error(data.msg, toastOptions);
      }
      if (data.status === true) {
        localStorage.setItem("chat-app-user", JSON.stringify(data.user));
        navigate('/')
      }
    }
  };

  const handleValidation = () => {
    const { password, confirmPassword, username, email } = values;
    if (password !== confirmPassword) {
      toast.error("Password and Confirm Password should match", toastOptions);
      return false;
    } else if (username.length < 3) {
      toast.error("Name should have atleast 3 letters", toastOptions);
      return false;
    } else if (password.length < 8) {
      toast.error("Password must contain 8 characters", toastOptions);
      return false;
    } else if (email === "") {
      toast.error("Please enter a valid email", toastOptions);
      return false;
    } else {
      return true;
    }
  };

  const handleChange = (e) => {
    setValues({ ...values, [e.target.name]: e.target.value });
  };

  return (
    <>
      <FormConatiner>
        <form>
          <div className="brand">
            <img src={Logo} alt="logo" />
            <h1>Chatify</h1>
          </div>
          <input
            type="text"
            placeholder="Username"
            name="username"
            onChange={handleChange}
          />
          <input
            type="email"
            placeholder="email"
            name="email"
            onChange={handleChange}
          />
          <input
            type="password"
            placeholder="password"
            name="password"
            onChange={handleChange}
          />
          <input
            type="password"
            placeholder="Confirm password"
            name="confirmPassword"
            onChange={handleChange}
          />

          <button type="submit" onClick={handleSubmit}>
            Create User
          </button>
          <span>
            Already have an account?
            <NavLink to="/login">Login</NavLink>
          </span>
        </form>
      </FormConatiner>
      <ToastContainer />
    </>
  );
};
const FormConatiner = styled.div`
  height: 100vh;
  width: 100vw;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 1rem;
  align-items: center;
  background-color: #131324;
  .brand {
    display: flex;
    align-items: center;
    gap: 1rem;
    justify-content: center;
    img {
      height: 5rem;
    }
    h1 {
      color: #fff;
      text-transform: uppercase;
    }
  }
  form {
    display: flex;
    flex-direction: column;
    gap: 2rem;
    background-color: #00000076;
    border-radius: .8rem;
    padding: 1rem 3rem;
    input {
      background-color: transparent;
      padding: .5rem;
      border: 0.1rem solid #4e0eff;
      border-radius: 0%.4rem;
      color: #fff;
      width: 100%;
      font-size: 1rem;
      &:focus {
        border: 0.1rem solid #997af0;
        outline: none;
      }
    }
    button {
      background-color: #e71ca8;
      color: #fff;
      padding: 1rem 2rem;
      border: none;
      font-weight: bold;
      cursor: pointer;
      border-radius: 0.4rem;
      font-size: 1rem;
      text-transform: uppercase;
      transition: 0.5s;
      &:hover {
        background-color: #4e0eff;
      }
    }
    span {
      color: #fff;
      text-transform: uppercase;
      a {
        color: #4e0eff;
        margin-left: 2px;
        text-decoration: none;
        font-weight: bold;
      }
    }
  }

  @media screen and (max-width: 700px) {
  .brand {
    gap: .8rem;
    img {
      height: 3rem;
    }
    h1 {
      font-size:1.4rem;
    }
  }
  form {
    align-items: center;
    gap: 1rem;
    border-radius: 1rem;
    padding: 1.3rem 2rem;
    input {
      width: 90%;
      padding: .4rem;
      border: 0.1rem solid #4e0eff;
      font-size: .8rem;
    }
    button {
      padding: .6rem 2rem;
      font-size: 1rem;
    }
  }
  }
  @media screen and (max-width: 400px) {
  
  form {
    height:400px;
    width:240px;
    button {
      padding: .3rem 1rem;
      font-size: .7rem;
    }
    span {
      width: 70%;
      font-size:.6rem;
      text-align: center;
    }
  }
  }
`;

export default Register;
